import { Card, Checkbox, DatePicker, Message } from '@alifd/next';
import {
  Button,
  Cascader,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useMemo, useState } from 'react';
import Swal from 'sweetalert2';

import useService from '@/lib/hooks/useService';
import { generateHouseHoldNumberCascader } from '@/utils/generateHouseHoldNumberCascader';

import ContentList from '../ContentList';
import styles from './index.module.scss';

const { Item } = Form;

const dd = new Date();
const months =
  '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月'.split(',');

const createArrayForYears = (length) => {
  const years = Array.from({ length }, (_, index) => {
    const year = (2020 + index).toString();
    return {
      value: year,
      label: year,
    };
  });
  return years;
};

const createMenu = {
  year: {
    type: 'select',
    text: '年份',
    required: true,
    isNumber: false,
    defaultValue: dd.getFullYear().toString(),
    options: createArrayForYears(11),
  },
  month: {
    type: 'select',
    text: '月份',
    required: true,
    isNumber: false,
    defaultValue: months[dd.getMonth()],
    options: months.map((month) => ({ value: month, label: month })),
  },

  householdNumber: {
    type: 'cascaderSelect',
    text: '戶號',
    required: true,
    isNumber: false,
  },
  status: {
    type: 'radio',
    text: '狀態',
    required: true,
    isNumber: false,
    options: [
      { value: '未登記', label: '未登記' },
      { value: '已登記', label: '已登記' },
      { value: '已截止', label: '已截止' },
    ],
  },
};

const createGasDataInitValues = {
  year: dd.getFullYear().toString(),
  month: months[dd.getMonth()],
  endTime: moment().endOf('M'),
};

const yearOptions = [
  {
    label: (dd.getFullYear() - 1).toString(),
    value: (dd.getFullYear() - 1).toString(),
  },
  {
    label: dd.getFullYear().toString(),
    value: dd.getFullYear().toString(),
  },
  {
    label: (dd.getFullYear() + 1).toString(),
    value: (dd.getFullYear() + 1).toString(),
  },
];

const monthOptions = months.map((month) => ({
  label: month,
  value: month,
}));

const editGasDataInitValues = {
  householdNumber: null,
  year: '',
  month: '',
  gasNumber: '',
};

const downloadGasDataInitValues = {
  householdNumber: null,
  downloadAll: false,
  year: dd.getFullYear().toString(),
  month: months[dd.getMonth()],
};

const GasList = () => {
  const [gas, updateGas, gasService] = useService({ collectionName: 'gas' });
  const [residentAccountNumbers] = useService({
    collectionName: 'residentAccountNumbers',
  });

  const householdNumbers = useMemo(
    () => residentAccountNumbers.map((resident) => resident.householdNumber),
    [residentAccountNumbers]
  );

  const [createGasDataForm] = Form.useForm();
  const [editGasDataForm] = Form.useForm();
  const [downloadGasDataForm] = Form.useForm();

  const [addGasData, setAddGasData] = useState(false);
  const [editGasDialog, setEditGasDialog] = useState(false);
  const [downloadDialog, setDownloadDialog] = useState(false);
  const [downloadAll, setDownloadAll] = useState(false);
  const [gasYear, setGasYear] = useState(dd.getFullYear().toString());
  const [gasMonth, setGasMonth] = useState(months[dd.getMonth()]);
  const [isDataDealing, setIsDataDealing] = useState(false);

  const tarTable = 'gas'; // CRUD之 Table Name
  const residentTable = 'residentAccountNumbers'; // 住戶之 Table Name
  const [filterKeys, setFilterKeys] = useState({
    month: [months[dd.getMonth()]],
    year: dd.getFullYear().toString(),
  }); // 過濾器 keys obj

  // 刪除
  const gasRemove = useCallback(
    (id) => {
      return new Promise((resolve, reject) => {
        try {
          gasService.remove(id).then((result) => {
            resolve(result);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    [gasService]
  );

  // 戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbers.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childsObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childsObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childsObj[ky].children) {
            // 加入到上一層children
            childsObj[ky].children = [childsObj[ee]];
          } else {
            childsObj[ky].children.push(childsObj[ee]);
            childsObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childsObj[Object.keys(childsObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    // console.log(FinalData);
    return FinalData;
  }

  // 下載全部住戶抄錶(Excel)
  function downloadAllResidentExcel(gasYear, gasMonth) {
    // 20220325 下載瓦斯抄錶新增選擇年月
    return new Promise((resolve, reject) => {
      try {
        resolve(
          (window.location.href = `/ezcon/api/getGasExcel?year=${gasYear}&month=${gasMonth}`)
        );
      } catch (error) {
        reject(error);
        Message.error('下載失敗!');
      }
    });
  }
  // 下載住戶抄錶(Excel)
  function downloadResidentExcel(downloadHousehold, gasYear, gasMonth) {
    // 20220325 下載瓦斯抄錶新增選擇年月
    return new Promise((resolve, reject) => {
      try {
        resolve(
          (window.location.href = `/ezcon/api/getGasExcel?houseNumber=${downloadHousehold}&year=${gasYear}&month=${gasMonth}`)
        );
      } catch (error) {
        reject(error);
        Message.error('下載失敗!');
      }
    });
  }

  const addNowYearData = async (formValues) => {
    const { year: gasYear, month: gasMonth, endTime } = formValues;
    let isDataDuplicate = false;
    for (let i = 0; i < residentAccountNumbers.length; i++) {
      // 判斷戶號是否有建立該年該月瓦斯抄錶資料
      // 20220323 修改為依照建立時間建立假資料
      try {
        const result = await gasService.find({
          query: {
            householdNumber: residentAccountNumbers[i].householdNumber,
            year: gasYear,
            month: gasMonth,
          },
        });
        if (result.total === 0) {
          // 若為空則建立一筆
          const formData = new FormData();
          formData.append('createdTime', '');
          formData.append('updatedTime', '');
          formData.append('year', gasYear);
          formData.append('month', gasMonth);
          formData.append(
            'householdNumber',
            residentAccountNumbers[i].householdNumber
          );
          formData.append('gasNumber', '');
          formData.append('endTime', moment(endTime).valueOf());
          formData.append('status', '未登記');

          try {
            await axios('/uploads?type=gas', {
              method: 'POST',
              headers: {
                authorization: window.localStorage['feathers-jwt'],
              },
              data: formData,
            });
          } catch (error) {
            isDataDuplicate = true;
            console.error(error);
            Message.error('資料建立失敗!');
          }
        } else {
          isDataDuplicate = true;
        }
      } catch (error) {
        console.error(error);
      }
    }
    createGasDataForm.resetFields();
    setIsDataDealing(false);
    setAddGasData(false);
    updateGas();
    isDataDuplicate
      ? Message.error('已有資料!')
      : Message.success('資料建立成功!');
  };

  // 日期格式處理
  const disabledDate = (date) => {
    return (
      date.valueOf() <=
      moment(`${gasYear}${months.indexOf(gasMonth) + 1}`, 'YYYYMM')
        .startOf('M')
        .valueOf()
    );
  };

  // 過濾器
  async function fakeData(val, key) {
    const cloneFilterKeys = { ...filterKeys };

    if (val === undefined || val === null || val.length === 0) {
      delete cloneFilterKeys[key];
      cloneFilterKeys[key];
    } else if (val !== '') {
      console.log(val);
      console.log(key);
      cloneFilterKeys[key] = val;
    }
    setFilterKeys({ ...cloneFilterKeys });
  }

  // 20220322 一鍵通知住戶功能
  const NotifyHouseNumber = async () => {
    // console.log(gasArr);
    const filterGasArr = gas.filter((item) => {
      return (
        item.month === months[dd.getMonth()] &&
        item.year === dd.getFullYear().toString() &&
        item.status === '未登記'
      );
    });
    try {
      const promises = [];
      for (let i = 0; i < filterGasArr.length; i++) {
        // 並根據未登記推播給住戶
        promises.push(
          axios('/ezcon/api/emitMsgQuery', {
            method: 'POST',
            headers: {
              authorization: window.localStorage['feathers-jwt'],
            },
            data: {
              service: 'message',
              event: 'msg',
              title: '瓦斯抄表通知',
              content: `尚未登記瓦斯度數，請於${months[dd.getMonth()]}底前登記`,
              type: 'success',
              class: 'gas',
              duration: 8000,
              redirect: '/ezpro/gas/gasFrontDesk',
              query: {
                householdNumbers: {
                  $in: [filterGasArr[i].householdNumber],
                },
                firebaseClass: '瓦斯抄錶',
              },
            },
          })
        );
      }
      await Promise.all(promises);
      Message.success('通知成功');
    } catch (error) {
      console.error(error);
      Message.error('通知失敗');
    }
  };

  const columnSorter = (a, b, dataIndex) => {
    if (dataIndex === 'month') {
      return months.indexOf(a[dataIndex]) - months.indexOf(b[dataIndex]);
    }
    if (typeof a[dataIndex] === 'number' && typeof b[dataIndex] === 'number') {
      return a[dataIndex] - b[dataIndex];
    }
    if (typeof a[dataIndex] === 'number' && typeof b[dataIndex] !== 'number') {
      return moment(a[dataIndex])
        .format('YYYY-MM-DD HH:mm:ss')
        .localeCompare(b[dataIndex]);
    }
    return a[dataIndex].localeCompare(b[dataIndex]);
  };

  const tableColumns = useMemo(() => {
    return [
      {
        title: '年份',
        dataIndex: 'year',
        sorter: (a, b) => columnSorter(a, b, 'year'),
      },
      {
        title: '月份',
        dataIndex: 'month',
        sorter: (a, b) => columnSorter(a, b, 'month'),
      },
      {
        title: '戶號',
        dataIndex: 'householdNumber',
        sorter: (a, b) => columnSorter(a, b, 'householdNumber'),
      },
      {
        title: '抄錶度數',
        dataIndex: 'gasNumber',
        sorter: (a, b) => columnSorter(a, b, 'gasNumber'),
        render: (value) => {
          if (value !== '') {
            return <>{value}</>;
          } else {
            return <>住戶尚未建立</>;
          }
        },
      },
      {
        title: '狀態',
        dataIndex: 'status',
        sorter: (a, b) => columnSorter(a, b, 'status'),
      },
      {
        title: '建立時間',
        dataIndex: 'createdTime',
        sorter: (a, b) => columnSorter(a, b, 'createdTime'),
        render: (value) => {
          if (value !== '') {
            return <>{moment(value).format('YYYY-MM-DD HH:mm:ss')}</>;
          } else {
            return <>住戶尚未建立</>;
          }
        },
      },
      {
        title: '更新時間',
        dataIndex: 'updatedTime',
        sorter: (a, b) => columnSorter(a, b, 'updatedTime'),
        render: (value) => {
          if (value !== '') {
            return <>{moment(value).format('YYYY-MM-DD HH:mm:ss')}</>;
          } else {
            return <>住戶尚未建立</>;
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 200,
        fixed: 'right',
        render: (_value, record) => {
          if (record.status !== '已截止') {
            return (
              <div className={styles.btn}>
                <Button
                  className={styles.buttonEdit}
                  type="normal"
                  onClick={() => {
                    editGasDataForm.setFieldsValue({
                      householdNumber: record.householdNumber,
                      gasNumber: record.gasNumber,
                      year: record.year,
                      month: record.month,
                    });
                    setEditGasDialog(true);
                  }}
                >
                  編輯
                </Button>

                <Button
                  type="primary"
                  danger
                  onClick={async () => {
                    const item = record;
                    const result = await Swal.fire({
                      title: `確定刪除(${record.householdNumber})資料?`,
                      text: '刪除後將無法復原!!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#BEBEBE',
                      confirmButtonText: '確定',
                      cancelButtonText: '取消',
                    });
                    try {
                      if (result.isConfirmed) {
                        await gasRemove(item._id);
                        updateGas();
                        Swal.fire('刪除!', '此筆資料已刪除', 'success');
                      }
                    } catch (error) {
                      console.error(error);
                      Message.error('資料刪除失敗!');
                    }
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }
        },
      },
    ];
  }, [editGasDataForm, gasRemove, updateGas]);

  const tableDataSource = useMemo(() => {
    let dataSource = gas;

    dataSource = dataSource.filter((item) => {
      if (
        filterKeys.householdNumber &&
        item.householdNumber !== filterKeys.householdNumber
      ) {
        return false;
      }
      if (filterKeys.status && item.status !== filterKeys.status) {
        return false;
      }
      if (filterKeys.year && item.year !== filterKeys.year) {
        return false;
      }
      if (filterKeys.month && !filterKeys.month?.includes(item.month)) {
        return false;
      }
      return true;
    });

    return dataSource;
  }, [
    filterKeys.householdNumber,
    filterKeys.month,
    filterKeys.status,
    filterKeys.year,
    gas,
  ]);

  const closeFormModal = (form) => {
    form.resetFields();
    switch (form.__INTERNAL__.name) {
      case 'download':
        setDownloadAll(false);
        setDownloadDialog(false);
        return;

      case 'edit':
        setEditGasDialog(false);
        return;

      default:
        setAddGasData(false);
        return;
    }
  };

  const handleCreateDataSubmit = (values) => {
    setIsDataDealing(true);
    addNowYearData(values);
  };

  const handleCreateFormChange = (changedValues) => {
    if ('year' in changedValues) {
      createGasDataForm.setFieldValue(
        'endTime',
        moment(
          moment(
            `${changedValues.year}${
              months.indexOf(createGasDataForm.getFieldValue('month')) + 1
            }`,
            'YYYYMM'
          ).endOf('M')
        )
      );
    }
    if ('month' in changedValues) {
      createGasDataForm.setFieldValue(
        'endTime',
        moment(
          moment(
            `${createGasDataForm.getFieldValue('year')}${
              months.indexOf(changedValues.month) + 1
            }`,
            'YYYYMM'
          ).endOf('M')
        )
      );
    }
  };

  const handleEditDataSubmit = async (values) => {
    const {
      householdNumber,
      year: gasYear,
      month: gasMonth,
      gasNumber,
    } = values;

    // 20220323 修改為先查詢新增年月是否有資料，若有則更新
    try {
      const res = await gasService.find({
        query: {
          householdNumber,
          month: gasMonth,
          year: gasYear,
        },
      });

      const isLessThan =
        parseInt(gasNumber, 10) < parseInt(res.data[0].gasNumber, 10);
      const isSame =
        parseInt(gasNumber, 10) === parseInt(res.data[0].gasNumber, 10);
      const lessThanOrEqual = isLessThan ? '小於' : '等於';

      if (isLessThan || isSame) {
        const result = await Swal.fire({
          title: `本次度數:${gasNumber}${lessThanOrEqual}上一次度數:${res.data[0].gasNumber}`,
          text: '請確定抄錶度數，送出後將無法復原!!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#BEBEBE',
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        });
        if (result.isConfirmed) {
          const newObject = {
            ...res.data[0],
            updatedTime: new Date().getTime(),
            gasNumber,
            status: '已登記',
          };
          try {
            const res = await gasService.patch(newObject._id, newObject);
            console.log('==gas create result success:', res.data);
            updateGas();
            setEditGasDialog(false);
            Message.success('新增成功');
          } catch (error) {
            console.log('==gas create fail:', error);
            Message.error(`${error}`);
          }
        }
      } else {
        const newObject = {
          ...res.data[0],
          createdTime: new Date().getTime(),
          updatedTime: new Date().getTime(),
          gasNumber,
          status: '已登記',
        };
        try {
          const res = await gasService.patch(newObject._id, newObject);
          console.log('==gas create result success:', res.data);
          updateGas();
          setEditGasDialog(false);
          Message.success('新增成功');
        } catch (error) {
          console.log('==gas create fail:', error);
          Message.error(`${error}`);
        }
      }
    } catch (error) {
      console.log('==gas find final data fail:', error);
    }
  };

  const handleDownloadDataSubmit = (values) => {
    const { downloadAll, year, month } = values;
    const householdNumber = values.householdNumber.join('-');

    if (downloadAll) {
      downloadAllResidentExcel(year, month);
      setDownloadAll(false);
      Message.success('下載成功!');
    } else {
      downloadResidentExcel(householdNumber, year, month);
      Message.success('下載成功!');
    }
    closeFormModal(downloadGasDataForm);
  };

  const downloadFormCascaderOptions = useMemo(() => {
    return generateHouseHoldNumberCascader(householdNumbers);
  }, [householdNumbers]);

  const handleDownloadFormValuesChange = (changedValues) => {
    if ('downloadAll' in changedValues) {
      const downloadAll = changedValues.downloadAll;
      setDownloadAll(changedValues.downloadAll);
      downloadGasDataForm.setFieldValue(
        'householdNumber',
        downloadAll ? ['下載全部資料'] : []
      );
    }
  };

  return (
    <>
      <div className={styles.downloadBox}>
        <Button
          type="primary"
          className={styles.buttonAdd}
          onClick={() => setAddGasData(true)}
        >
          建立資料
        </Button>
        <Button
          type="secondary"
          className={styles.exportBtn}
          onClick={() => setDownloadDialog(true)}
        >
          下載住戶抄錶
        </Button>

        <Button
          type="secondary"
          className={styles.exportBtn}
          onClick={NotifyHouseNumber}
        >
          一鍵通知住戶
        </Button>
      </div>

      {/* 下載個別住戶Excel */}
      <Modal
        className={styles.dialog}
        open={downloadDialog}
        footer={null}
        onCancel={() => closeFormModal(downloadGasDataForm)}
      >
        <Form
          form={downloadGasDataForm}
          name="download"
          onFinish={handleDownloadDataSubmit}
          onValuesChange={handleDownloadFormValuesChange}
          initialValues={downloadGasDataInitValues}
        >
          <h3>選擇戶號</h3>

          <div className={styles['download-dialog-household-select']}>
            <Item
              label="戶號"
              name="householdNumber"
              rules={[{ required: true, message: '請選擇戶號' }]}
            >
              <Cascader
                placeholder="請選擇戶號"
                options={downloadFormCascaderOptions}
                disabled={downloadAll}
              />
            </Item>
            <Item name="downloadAll" valuePropName="checked">
              <Checkbox>全部</Checkbox>
            </Item>
          </div>
          <Item
            label="抄錶年份"
            name="year"
            rules={[{ required: true, message: '請選擇抄錶年份' }]}
          >
            <Select placeholder="請選擇抄錶年份" options={yearOptions} />
          </Item>
          <Item
            label="抄錶月份"
            name="month"
            rules={[{ required: true, message: '請選擇抄錶月份' }]}
          >
            <Select placeholder="請選擇抄錶月份" options={monthOptions} />
          </Item>
          <Item>
            <Space className={styles.formFooterButtons}>
              <Button type="primary" htmlType="submit">
                確定
              </Button>
              <Button onClick={() => closeFormModal(downloadGasDataForm)}>
                取消
              </Button>
            </Space>
          </Item>
        </Form>
      </Modal>

      {/* 編輯 */}
      <Modal
        className={styles.dialog}
        open={editGasDialog}
        footer={null}
        onCancel={() => closeFormModal(editGasDataForm)}
      >
        <Form
          form={editGasDataForm}
          name="edit"
          onFinish={handleEditDataSubmit}
          initialValues={editGasDataInitValues}
        >
          <h3>編輯瓦斯抄錶</h3>

          <Item
            label="戶號"
            name="householdNumber"
            rules={[{ required: true }]}
          >
            <p className={styles.editFormItem}>
              {editGasDataForm.getFieldValue('householdNumber')}
            </p>
          </Item>
          <Item label="年份" name="year" rules={[{ required: true }]}>
            <p className={styles.editFormItem}>
              {editGasDataForm.getFieldValue('year')}
            </p>
          </Item>

          <Item label="月份" name="month" rules={[{ required: true }]}>
            <p className={styles.editFormItem}>
              {editGasDataForm.getFieldValue('month')}
            </p>
          </Item>

          <Item
            label="抄錶度數"
            name="gasNumber"
            rules={[
              {
                required: true,
              },
              {
                message: '僅限輸入數字',
                pattern: /^[0-9]*$/,
                transform: (value) => (value ? value.toString() : undefined),
              },
              {
                min: 4,
                type: 'string',
              },
            ]}
          >
            <Input
              maxLength={5}
              placeholder="請輸入抄錶度數"
              className={styles.gasNumberInput}
            />
          </Item>
          <h3>瓦斯登記範例</h3>
          <p>由左至右輸入度數，紅色區域不須填寫</p>
          <img
            style={{ width: '100%', height: '200px' }}
            src="img/image_gas meter.svg"
            alt="圖片"
          />
          <Item>
            <Space className={styles.formFooterButtons}>
              <Button type="primary" htmlType="submit">
                確定
              </Button>
              <Button onClick={() => closeFormModal(editGasDataForm)}>
                取消
              </Button>
            </Space>
          </Item>
        </Form>
      </Modal>

      {/* 20220323建立資料 */}
      <Modal
        className={styles.dialog}
        open={addGasData}
        footer={null}
        onCancel={() => closeFormModal(createGasDataForm)}
      >
        <Form
          form={createGasDataForm}
          name="create"
          onFinish={handleCreateDataSubmit}
          onValuesChange={handleCreateFormChange}
          initialValues={createGasDataInitValues}
        >
          <h3>新增瓦斯抄錶資料</h3>

          <Item
            label="抄錶年份"
            name="year"
            rules={[{ required: true, message: '請選擇抄錶年份' }]}
          >
            <Select placeholder="請選擇抄錶年份" options={yearOptions} />
          </Item>
          <Item
            label="抄錶月份"
            name="month"
            rules={[{ required: true, message: '請選擇抄錶月份' }]}
          >
            <Select placeholder="請選擇抄錶月份" options={monthOptions} />
          </Item>
          <Item
            label="截止日期"
            name="endTime"
            rules={[{ required: true, message: '請選擇截止日期' }]}
          >
            <DatePicker disabledDate={disabledDate} />
          </Item>
          <Item>
            <Space className={styles.formFooterButtons}>
              <Button type="primary" htmlType="submit" loading={isDataDealing}>
                確定
              </Button>
              <Button
                onClick={() => closeFormModal(createGasDataForm)}
                disabled={isDataDealing}
              >
                取消
              </Button>
            </Space>
          </Item>
        </Form>
      </Modal>

      <Card free>
        <Card.Content>
          <ContentList
            menuData={createMenu}
            tableName={tarTable}
            residentTable={residentTable}
            householdNumbers={ParseStringToArrayObject()}
            filterProps={(val, key) => {
              fakeData(val, key);
            }}
          />
          <Table
            columns={tableColumns}
            dataSource={tableDataSource}
            scroll={{ x: 'max-content' }}
            rowKey="_id"
          >
            {/* <Table.Column title="期別" dataIndex="gasMonth" width={150} /> */}
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default GasList;
